<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Usuários</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            :show-print-button="false"
            :show-column-visibility-button="false"
            title="Listagem de Usuários"
            api-url="escala/listar-usuarios"
            report-title="Usuários"
            :fields="fields"
            :appendParams="{ filter }"
          >
            <template slot="filters">
              <div class="" id="filtros">
                <div class="col-sm-10">
                  <input
                    type="search"
                    v-model="filter"
                    @keyup="consultar"
                    class="form-control"
                    placeholder="Pesquise aqui por usuário, email ou nome..."
                  />
                </div>
                <div class="col-sm-2">
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'escalas_user_save' }"
                  >
                    <font-awesome-icon :icon="'plus'" />
                    Adicionar
                  </router-link>
                </div>
              </div>
            </template>

            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'pencil-alt'" />
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'

export default {
  name: 'users',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'username',
          sortField: 'username',
          title: 'Usuário',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: 'USU_DCEMAIL',
          sortField: 'USU_DCEMAIL',
          title: 'Email',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: 'USU_NMUSUARIO',
          sortField: 'USU_NMUSUARIO',
          title: 'Nome',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ],
      filter: ''
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'escalas_user_save',
        params: {
          data: data
        }
      })
    },
    consultar() {
      const {
        filter: { length: filterLength }
      } = this
      if (filterLength === 0 || filterLength > 2) this.$refs.vuetable.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/escalas/users/index.vue